//在此处编写调用授权等基本平台接口
import store from '@/store/'
class em_api {
	constructor(axiosFactory) {
		this.$http = axiosFactory;
	}
	http() {
		return this.$http;
	}
	get(url, cb) {
		this.$http.get(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});;
	}
	gets(url, data, cb) {
		this.$http.get(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	post(url, data, cb) {
		this.$http.post(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	posts(url, cb) {
		this.$http.post(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	put(url, data, cb) {
		this.$http.put(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	puts(url, cb) {
		this.$http.put(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	delete(url, data, cb) {
		this.$http.delete(url, data).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	deletes(url, cb) {
		this.$http.delete(url).then(res => {
			cb(res.data);
		}).catch(err => {
			cb(err);
		});
	}
	//先判定本地是否存储，如果没有能够获取到本地存储，再次从远程获取；
	//name存储字段，url请求地址，cb回调函数
	getStorageData(name, url, cb) {
		var myObj = JSON.parse(localStorage.getItem(name));
		if (myObj) {
			cb(myObj);
		} else {
			this.$http.get(url).then(data => {
				cb(data.data);
				localStorage.setItem(name, JSON.stringify(data.data));
			});
		}
	}
	//------------------------------------------------------------
	//获取通知列表
	getchatNotice(cb) {
		this.get(`/my/advise?pageSize=50&pageNum=1`, cb)
	}
	putchatNotice(index,cb){
		this.put(`/my/advise/new?logId=${index}&read=true`,cb)
	}
	getemRobotmsg(data, cb) {
		this.get(
			`/chat/robot/with/${data.from}?pageSize=50&pageNum=1`,
			cb
		);
	}
	getEMchatLogs(data, cb) {
		this.get(
      `/my/chatLogs/dialog?pageSize=50&pageNum=1&from=${data.from}&chatTo=${data.to}`,
			cb
		);
	};
	putChatLogs(chatTo, cb) {
		// chatTo
		this.puts(
			`/my/chatLogs?chatTo=${chatTo}`,
			cb
		);
	};
	getemchatLogs(data, cb) {
		if (data.to == 'BeilieRobot') {
			this.get(
				`/my/robot/chatLogs?pageSize=20&pageNum=${data.pageNum}&currentDate=${data.currentDate}`,
				cb
			);
		} else {
			this.get(
				`/my/chatLogs?pageSize=20&pageNum=${data.pageNum}&from=${
		    data.from
		  }&chatTo=${data.to}&currentDate=${data.currentDate}`,
				cb
			);
		}
	};
	deleteschatLogs(chatId, cb) {
		this.deletes(`/my/contactor/${chatId}`, cb)
	};

	getRobotContact(userName, cb) {
		this.get(`/${userName}/contact/robot`, cb);
	}
	putRobotContactread(userName, cb) {
		this.puts(
			`/${userName}/contact/robot/read`,
			cb
		);
	};
}
class apiFactory {
	constructor() {

	}
	createApi(axios) {
		return new em_api(axios)
	}
}
export default new apiFactory();
